<template>
    
    <section class="hero-section">
      <swiper
        :style="{
          '--swiper-navigation-color': '#ffea00',
          '--swiper-pagination-color': '#ffea00',
        }"
        :modules="modules"
        :slides-per-view="1"
        :space-between="0"
        :effect="'fade'"
        :pagination="{ clickable: true}"
        :autoplay="{ delay: 6000, disableOnInteraction: false }"
        @slideChange="onHeroSlideChange"
      >
          <swiper-slide>
            <div
              class="bg-[url(/img/hero/hero_1_bg.jpg)] bg-no-repeat bg-center bg-cover h-[500px] max-h-[500px] lg:min-h-[300px] sm:min-h-[200px]">
              <div class="container">
                <div class="grid grid-cols-12 gap-4 items-center pt-20">
                  <div class="sm:col-span-6 col-span-12 flex justify-center pb-3 sm:pt-0 pt-4">
                    <div v-if="heroActiveIndex === 1" class="w-2/5 block md:hidden lg:hidden"  data-aos="fade-right">
                      <img class="pointer-events-none" src="/img/hero/hero_1_title_1.png" alt="" />
                    </div>
                    <div v-if="heroActiveIndex === 1" class="w-[55%] hidden md:block lg:block"  data-aos="fade-right">
                      <img class="pointer-events-none" src="/img/hero/hero_1_title_2.png" alt="" />
                    </div>
                  </div>
        
                  <div v-if="heroActiveIndex === 1" class="sm:col-span-6 col-span-12 relative z-30 flex justify-center" data-aos="zoom-in">
                    <div class="relative z-0 overflow-hidden h-2/3 w-2/3 pt-5 pointer-events-none">
                      <img class="vert-move" src="/img/hero/hero_1.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div
              class="bg-[url(/img/hero/hero_2_bg.jpg)] bg-no-repeat bg-center bg-cover h-[500px] max-h-[500px] lg:min-h-[300px] sm:min-h-[200px]">
              <div class="container">
                <div class="grid grid-cols-12 gap-4 items-center pt-20">
                  <div class="sm:col-span-6 col-span-12 flex justify-center pb-3 sm:pt-0 pt-4">
                    <div v-if="heroActiveIndex === 2" class="w-2/5 block md:hidden lg:hidden"  data-aos="fade-right">
                      <img class="pointer-events-none" src="/img/hero/hero_2_title_1.png" alt="" />
                    </div>
                    <div v-if="heroActiveIndex === 2" class="w-[55%] hidden md:block lg:block"  data-aos="fade-right">
                      <img class="pointer-events-none" src="/img/hero/hero_2_title_2.png" alt="" />
                    </div>
                  </div>
        
                  <div class="sm:col-span-6 col-span-12 relative z-30 flex justify-center">
                    <div v-if="heroActiveIndex === 2" class="relative z-0 overflow-hidden h-2/3 w-2/3 pt-5 pointer-events-none" data-aos="zoom-in">
                      <img class="vert-move" src="/img/hero/hero_2.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
          <swiper-slide>
            <div
              class="bg-[url(/img/hero/hero_3_bg.jpg)] bg-no-repeat bg-center bg-cover h-[500px] max-h-[500px] lg:min-h-[300px] sm:min-h-[200px]">
              <div class="container">
                <div class="grid grid-cols-12 gap-4 items-center pt-20">
                  <div class="sm:col-span-6 col-span-12 flex justify-center pb-3 sm:pt-0 pt-4">
                    <div v-if="heroActiveIndex === 3" class="w-2/5 block md:hidden lg:hidden" data-aos="fade-right">
                      <img class="pointer-events-none" src="/img/hero/hero_3_title_1.png" alt="" />
                    </div>
                    <div v-if="heroActiveIndex === 3" class="w-[55%] hidden md:block lg:block" data-aos="fade-right">
                      <img class="pointer-events-none" src="/img/hero/hero_3_title_2.png" alt="" />
                    </div>
                  </div>
        
                  <div class="sm:col-span-6 col-span-12 relative z-30 flex justify-center">
                    <div v-if="heroActiveIndex === 3" class="relative z-0 overflow-hidden h-2/3 w-2/3 pt-5 pointer-events-none" data-aos="zoom-in">
                      <img class="vert-move" src="/img/hero/hero_3.png" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
      </swiper>
      <!-- down section start -->
      <div class="bg-primary py-2 globl z-40 down-section">
        <div class="-rotate-3 bg-nu2 py-4 -mx-5 -z-10">
          <swiper
          :spaceBetween="50"
          :centeredSlides="true"
          :speed="2500"
          :autoplay="{
            delay: 0,
            disableOnInteraction: false,
            slidesPerView: 6,
          }"
          :loop="true"
          :modules="modules"
          class="swiper brand-carouselOne"
          :breakpoints="{
            1400: {
              slidesPerView: 6,
            },
            1200: {
              slidesPerView: 6,
            },
            992: {
              slidesPerView: 5,
            },
            768: {
              slidesPerView: 4,
            },
            578: {
              slidesPerView: 3,
            },
            375: {
              slidesPerView: 2,
            },
          }"
        >
        <swiper-slide v-for="item in indexJson.game_type" :key="item.id">
          <div class="swiper-slide !w-fit">
            <div class="items-wrapper">
              <div class="flex items-center gap-3">
                <img class="w-[80px] h-auto" :src="item.icon" alt="Icon" />
                <h5 class="text-nu1">{{ item.title }}</h5>
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide v-for="item in indexJson.game_type" :key="item.id">
          <div class="swiper-slide !w-fit">
            <div class="items-wrapper">
              <div class="flex items-center gap-3">
                <img class="w-[80px] h-auto" :src="item.icon" alt="Icon" />
                <h5 class="text-nu1">{{ item.title }}</h5>
              </div>
            </div>
          </div>
        </swiper-slide>
        </swiper>
        </div>
      </div>
      <!-- down section end -->
    </section>  
    
    <!-- Our Games section start -->
    <section class="bg-nu2 overflow-hidden allGamesSection lg:py-[60px] md:py-20 py-[60px]">
      <div class="container">
        <div class="sm:py-4 py-3">
          <div class="flex max-sm:flex-wrap justify-between items-center gap-4 sm:pb-8 pb-4">
            <div class="flex items-center" data-aos="fade-right">
              <h2 class="text-nu1 bf-color">Our Games</h2>
            </div>
            <div class="" data-aos="fade-left">
              <a href="/game" class="card2 px-4 py-2 text-nu1">View More
              </a>
            </div>
          </div>
        </div>
        <div class="grid grid-cols-12 sm:gap-6 gap-4">
          <!-- card 1 -->
          <Game v-for="game, index in recentGames" :key="game.id" :game="game"></Game>
        </div>
    </div>
  </section>
  <!-- Our Games section end -->

  <!-- Explore Our Features section start -->
  <section class="exploreFeatures-section lg:py-[60px] md:py-20 py-[60px] bg-nu2 overflow-hidden">
    <div class="container relative">
      <div class="flex justify-between items-center sm:pb-10 pb-6">
        <div class="sm:flex items-center inline-block" data-aos="fade-right">
          <h2 class="text-nu1 bf-color">Our Features</h2>
        </div>
      </div>
      <div>
        <div class="flex justify-between gap-2 px-10">
          <div 
            v-for="feature in indexJson.features"
            :key="feature.id"
            class="w-1/8 max-w-32 transform flex flex-col items-center"
            :class="feature.id == activeFeature ? 'scale-110' : ''"
            @click="activeFeature = feature.id">
            <div>
              <img :src="feature.icon" alt="" />
            </div>
            <span class="md:text-sm text-[8px]" :class="feature.id == activeFeature ? 'feature-active font-bold' : 'text-white'">{{ feature.name }}</span>
            <span v-if="feature.id == activeFeature" class="triangle-top scale-100 mb-1"></span>
          </div>
        </div>
        <div class="w-full">
          <div 
            class="text-nu1 rounded-[20px] py-[40px] pl-10 bg-nu4 border-nu4"
            data-aos="fade-right">
            <span class="text-3xl mb-4 font-bold">{{ currFeature.name }}</span>
            <div class="bf-color-2 font-light">
              <span v-for="desc in currFeature.desc">
                {{ desc }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Our Features section end -->

  <!-- Explore News section start -->
  <section class="exploreGame-section lg:py-[60px] md:py-20 py-[60px] bg-nu2 overflow-hidden">
    <div class="container relative">
      <div class="flex justify-between items-center sm:pb-10 pb-6">
        <div class="sm:flex items-center inline-block" data-aos="fade-right">
          <h2 class="text-nu1 bf-color">Big News</h2>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4 tab-block" id="tab-block">
        <ul class="md:col-span-4 col-span-12 tab-mnu" data-aos="fade-up">
          <li class="text-nu1 text-xl pl-2" :class="activeTab == 0 ? 'active' : ''" @click="activeTab=0">Latest Games</li>
          <li class="text-nu1 text-xl pl-2" :class="activeTab == 1 ? 'active' : ''" @click="activeTab=1">Featured Videos</li>
          <li class="text-nu1 text-xl pl-2" :class="activeTab == 2 ? 'active' : ''" @click="activeTab=2">Popular Games</li>
          <li class="text-nu1 text-xl pl-2" :class="activeTab == 3 ? 'active' : ''" @click="activeTab=3">Top Trending</li>
        </ul>

        <div class="md:col-span-8 col-span-12 tab-cont">
          <!-- 1 -->
          <div v-if="activeTab == 0" class="tab-pane grid grid-cols-12 items-center gap-4" data-aos="fade-left">
            <div class="col-span-12 relative">
              <div class="img-box rounded-2xl">
                <img class="w-full rounded-3xl img" src="/img/event/event_01.jpg" alt="" />
              </div>
            </div>
          </div>
          <div v-if="activeTab == 1" class="tab-pane grid grid-cols-12 items-center gap-4" data-aos="fade-left">
            <div class="col-span-12 relative">
              <div class="img-box rounded-2xl">
                <img quality="80" class="w-full rounded-3xl img" src="/img/event/event_02.jpg" alt="" />
              </div>
            </div>
          </div>
          <div v-if="activeTab == 2" class="tab-pane grid grid-cols-12 items-center gap-4" data-aos="fade-left">
            <div class="col-span-12 relative">
              <div class="img-box rounded-2xl">
                <img class="w-full rounded-3xl img" src="/img/event/event_03.jpg" alt="" />
              </div>
            </div>
          </div>
          <div v-if="activeTab == 3" class="tab-pane grid grid-cols-12 items-center gap-4" data-aos="fade-left">
            <div class="col-span-12 relative">
              <div class="img-box rounded-2xl">
                <img class="w-full rounded-3xl img" src="/img/event/event_04.jpg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- Contact US section start -->
  <section class="bg-primary globl">
    <div class="bg-nu7 -rotate-3 sm:py-10 py-8 -mx-5">
      <div class="container rotate-3">
        <div class="flex justify-between items-center max-sm:flex-wrap">
          <h1 class="text-nu1 sm:pl-0 pl-4">Contact US</h1>
          <div
            class="sm:mx-0 mx-4 px-4 sm:py-1 py-0 flex items-center">
            <a href="https://i.q-chats.com/chatlink.html?tag=f83520b271cff45a8dcd71388caec217&language=en" target="_blank">
              <span class="pl-2">
                <img class="w-[10em]" src="/img/index/chat.png" alt="" />
              </span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>


<script setup>
  import AOS from 'aos';
  import { Swiper, SwiperSlide } from 'swiper/vue';
  // import required modules
  import { Autoplay, Pagination, Navigation, EffectFade } from 'swiper/modules';
  import indexJson from '~~/static/data/index.json';
  import gameJson from '~~/static/data/game.json';

  const modules = [Autoplay, Pagination, Navigation, EffectFade];
  const activeTab = ref(0);
  const activeFeature = ref(1);
  const timer = ref(null);
  const heroActiveIndex = ref(1);

  const payIcons = [
    '/img/pay/pay_01.png',
    '/img/pay/pay_02.png',
    '/img/pay/pay_03.png',
    '/img/pay/pay_04.png',
    '/img/pay/pay_05.png',
  ]

  const recentGames = computed(() => {
    return gameJson.games.slice(0, 4);
  })

  const currFeature = computed(() => {
    return indexJson.features.find((feature) => feature.id === activeFeature.value);
  })

  const onHeroSlideChange = (swiper) => {
    heroActiveIndex.value = swiper.realIndex + 1;
  }
  // 页面激活后，需要初始化aos
  onMounted(() => {
    AOS.init({
      duration: 2000,
      delay: 5000,
      once: true,
    });
    // 页面激活之后, 循环activeFeature
    timer.value = setInterval(() => {
      activeFeature.value = (activeFeature.value + 1) % indexJson.features.length;
      if (activeFeature.value === 0) {
        activeFeature.value = indexJson.features.length;
      }
      // console.log(activeFeature.value);
    }, 5000);
    // 随机显示一个页签
    activeTab.value = Math.floor(Math.random()* 100) % 4;
  });

  onBeforeUnmount(() => {
    // console.log('onBeforeUnmount');
    clearInterval(timer.value);
  });
</script>

<script>
  export default {
    name: 'Index',
  }
</script>

<style scoped lang="scss">
  /* 显示一个倒三角 */
  .triangle-top {
    width: 0;
    height: 0;
    border-left: 1em solid transparent;
    border-right: 1em solid transparent;
    border-bottom: 1.5em solid #18191f;
  }
  .feature-active {
    color: #ffea00;
  }
</style>
  